<div class="container my-3">
  <div class="row mb-3">
    <div class="col-md-6">
      <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchQuery" (input)="search()" data-cy="employee-search-input" />
    </div>

    <div class="col-md-6">
      <select class="form-select" [(ngModel)]="selectedJobTitle" (change)="filterByJobTitle()" data-cy="job-title-filter">
        <option value="">Todos os Cargos</option>
        <option *ngFor="let job of getUniqueJobTitles()" [value]="job">{{ job }}</option>
      </select>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-hover">
      <thead class="thead-light">
        <tr>
          <th *ngFor="let header of headers">
            <ng-container *ngIf="header == headers[0]; else elseTemplate" hidden></ng-container>
            <ng-template #elseTemplate>
              {{ header }}
            </ng-template>
          </th>
          <th></th>
          <!-- <th>Ações</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of paginatedData; let rowIndex = index" 
            [class.clickable-row]="isManager || isSupervisor"
            (click)="isManager || isSupervisor ? openAppointments(row) : null"
            [style.cursor]="(isManager || isSupervisor) ? 'pointer' : 'default'"
            [attr.data-cy]="'employee-row-' + rowIndex">
          <td *ngFor="let col of row; let i = index">
            <span *ngIf="i === 0" hidden>{{ col }}</span>
            <app-avatar *ngIf="i === 1" [src]="col" alt="Foto do funcionário" size="medium"></app-avatar>
            <span *ngIf="i !== 0 && i !== 1" [attr.data-cy]="i === 2 ? 'employee-name' : null">{{ col }}</span>
          </td>
          <td (click)="$event.stopPropagation()">
            <button *ngIf="isAdmin" class="btn btn-primary btn-sm mx-1" (click)="onEdit(row)" [attr.data-cy]="'edit-employee-' + rowIndex">
              <i class="bi bi-pencil-fill"></i>
            </button>
            <button *ngIf="isAdmin" class="btn btn-danger btn-sm" (click)="onDelete(row)" [attr.data-cy]="'delete-employee-' + rowIndex">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav aria-label="Table pagination">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1" data-cy="pagination-previous">Anterior</button>
      </li>

      <li
        class="page-item"
        *ngFor="let page of [].constructor(totalPages); let i = index"
        [class.active]="i + 1 === currentPage"
      >
        <button class="page-link" (click)="changePage(i + 1)" [attr.data-cy]="'pagination-page-' + (i + 1)">
          {{ i + 1 }}
        </button>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages" data-cy="pagination-next">
          Próximo
        </button>
      </li>
    </ul>
  </nav>
</div>
